import React, {useRef} from 'react'
import {useContainerEnterKeydown} from '@containers/hooks'
import {CheckboxBase} from './checkbox-base'
import {CheckboxNewProps} from './types'

export const CheckboxNew = (props: CheckboxNewProps) => {
  const keydownHandler = () => {
    props.onChange?.(!props.value)
  }
  const checkboxRef = useRef<HTMLInputElement>(null)

  useContainerEnterKeydown<HTMLInputElement>(checkboxRef, keydownHandler)

  return (
    <CheckboxBase
      {...props}
      ref={checkboxRef}
      onClick={e => props.onChange?.(!props.value, e)}
    />
  )
}
